export default __webpack_public_path__ + "static/media/pizza.3f796e5c.jpg";